// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__1lRpa","table":"List_table__2Ar3b","sorted":"List_sorted__M-x4A","increaseButton":"List_increaseButton__3s1bA"};